import { Employee, User } from "@finway-group/shared/lib/models"
import store from "Shared/store"

const UserService = {
    getLoggedInUserProfile: (): User => new User(store.getState().auth.user),
    getLoggedInEmployeeProfile: (): Employee => {
        const id = UserService.getLoggedInUserProfile().id
        return new Employee(store.getState().employees.items.find((employee: Employee) => employee.id === id))
    },
    getEmployeeProfile: (id: string): Employee => new Employee(UserService.getUserById(id)),
    getUserById: (id: string): Employee => store.getState().employees.items.find((employee: Employee) => employee.id === id),
}

export default UserService
